﻿export const MOUNT_APP = '#app';

export const STORAGE_EXPIRES_DEFAULT = 60 * 60 * 1000 * 24 // 1day
export const STORAGE_KEY_PAISES = 'countries'
export const STORAGE_KEY_PAISES_NO_SPAIN = 'countries-no-spain'
export const STORAGE_KEY_COMUNIDADES = 'comunidades'